import React from "react";
import {Grid, IconButton, Tooltip, Typography} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {useSelector} from "react-redux";
import {RootState} from "../../store/reducers";
import AlunoTabDiscDee from "./AlunoTabDiscDee";
import {iDisciplinaModulo} from "../../types/DisciplinaModulo";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import format from "date-fns/format";
import {isValid, parseISO} from "date-fns";
import { sharedStyles } from "./alunoDialogStyles";

const sxStyles = {
    mainExternoGrid: {
        ...sharedStyles.containerRow,
        margin: 0,
        backgroundColor: 'transparent'
    },
    mainInternoGrid: {
        ...sharedStyles.moduleCard,
    },
    tituloGrid: {
        justifyContent: 'center'
    },
}

interface iDiscModDialog  {
    registro: iDisciplinaModulo,
    eilId: number,
    dof: any[],
    dofParaMatricula: any[],
    colWidth?: string
}


const AlunoTabDiscDiscMod = ({ registro, eilId, dof , dofParaMatricula, colWidth } : iDiscModDialog ) => {

    const aluno = useSelector( (state : RootState) => state.cadastros.aluno );
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const  handleAddDee = (event: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLLIElement>, id: number) => {
        console.log("Adiciona dof em Dee", id);
        setAnchorEl(null);
    }

    const eil = aluno.enrollmentInLevel.find( (e: any) => e.id === eilId);
    if (!eil || (eil && !eil.enrollment)) { return (<Typography>Sem matricula/No Enroll.</Typography>)}

    let dee4dm : any[] = [];
    eil.enrollment.forEach( (e: any) => {
       const i: any[] = e.disciplineEntree.filter( (dee:any) => dee.disciplineOffer.DisciplineModule_id === registro.id );
       dee4dm.push(...i);
    });

    return (
        <React.Fragment>
            <Grid container item id={`gridDiscMod-${registro.id}`} sx={{
                ...sxStyles.mainExternoGrid,
                flex: '0 0 auto',
                width: colWidth || '420px',
                maxWidth: colWidth || '420px',
                minWidth: colWidth || '420px',
                margin: '0px',
                padding: '5px',
                marginBottom: '5px'
            }} >
                <Grid item container sx={{...sxStyles.mainInternoGrid}}>
                    <Grid item container sx={{...sxStyles.tituloGrid}} sm={11} md={11} lg={11} xl={11}>
                        <Tooltip title={`dmId:${registro.id}`}>
                            <div>
                                <Typography variant="body2" sx={{ fontWeight: 'medium' }}>{registro.Description}</Typography>
                                <Typography variant="caption" color="text.secondary">CH:{registro.WorkloadTotal} CP:{registro.WorkloadPresential}</Typography>
                            </div>
                        </Tooltip>
                    </Grid>
                    <Grid item container sx={{...sxStyles.tituloGrid}} sm={1} md={1} lg={1} xl={1}>
                        <Tooltip title="Adicionar oferta">
                            <IconButton
                                size="small"
                                onClick={handleClick}
                                aria-controls={open ? 'basic-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                                color="primary"
                            >
                                <AddCircleOutlineIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            MenuListProps={{
                                'aria-labelledby': 'basic-button',
                            }}
                        >
                            {
                                dofParaMatricula.map( (d: any, ix: number) => {
                                    return (<MenuItem key={ix} onClick={ (event) => handleAddDee(event, d.id)}>DOF #{d.id} (dm {d.disciplineModule.id}) {d.classOffer.Description} {d.classOffer.Room} - {d.period.Description}  {d.disciplineModule.discipline.Description} { isValid(parseISO(d.InitialDate))? format(parseISO(d.InitialDate),"dd/MM/yyyy") : ""} {`->`} { isValid(parseISO(d.EndDate))? format(parseISO(d.EndDate),"dd/MM/yyyy") : ""}</MenuItem>);
                                })
                            }
                        </Menu>
                    </Grid>
                    <Grid container item sm={12} md={12} lg={12} xl={12}>
                    {
                        dee4dm.map( (dee: any,ix: number) => {
                            return (<AlunoTabDiscDee key={ix} registro={dee} eilId={eilId}/>)
                        } )
                    }
                </Grid>
                </Grid>
            </Grid>
    </React.Fragment>);
}
export default (AlunoTabDiscDiscMod);
